module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "starDriverFavorite.33a4adca.png" + "?" + Date.now();